module.exports = __webpack_public_path__ + "static/media/5.IPhone4S.20a1e4d6.png";